import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=287a5d98&"
var script = {}
import style0 from "./empty.vue?vue&type=style&index=0&id=287a5d98&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports